
Office.onReady(() => {
    const hash = location.hash;
    if (hash.includes("token=")) {
        const fragment = hash.substring(1); // Removes the '#'
        // Parse into key-value pairs
        const params = new URLSearchParams(fragment);
        const tokenBase64 = decodeURIComponent(params.get("token"));
        const token = JSON.parse(atob(tokenBase64));
        // const userInfo = decodeURIComponent(params.get("userInfo"));
        Office.context.ui.messageParent(JSON.stringify({ status: "success", token }));
    } else {
        Office.context.ui.messageParent(JSON.stringify({ status: "error", message: "No token" }));
    }
});